import React from 'react';
import AvailabilityIndex from '@app/model/market_state/AvailabilityIndex';
import Tag from '@app/component/tag/Tag';
import Utilities from '@util/Utilities';
import { MarketStateStatDateCompetitorSnapshot } from '@app/model/market_state/MarketStateStatDateCompetitorSnapshot';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import DataProvider from '@app/model/_common/DataProvider';
import DataPlatform from '@app/model/_common/DataPlatform';
import {
	useMarketStateFilterInputTools
} from '@app/site/secured/rateshopper/rates/provider/useMarketStateFilterInputTools';

const DisplayAvailabilityIndexTag: React.FunctionComponent<{
	current: MarketStateStatDateCompetitorSnapshot
}> = ({ current }) => {

	const {companyHotel} = useSelectedCompanyHotel();
	const { filter } = useMarketStateFilterInputTools();

	if (current.isGroup) {
		const [availableHotels, totalHotels] = current.ratioAvailableHotelsOverTotal(companyHotel);
		const ratio = availableHotels / totalHotels;
		if (ratio >= 0.75) {
			return <Tag state="success">{availableHotels}/{totalHotels}</Tag>;
		}
		if (ratio >= 0.25) {
			return <Tag state="warning">{availableHotels}/{totalHotels}</Tag>;
		}
		if (ratio < 0.25) {
			return <Tag state="critical">{availableHotels}/{totalHotels}</Tag>;
		}
	}

	if (!current.getLowestItemForRoom()?.hasAvailability() && !current.getLowestItemForRoom()?.isSoldOut() && filter.provider !== DataProvider.BOOKING && filter.platform !== DataPlatform.WEB) {
		return <Tag state="none">Not Available</Tag>;
	}

	if (current.isNotSupported()) {
		return <Tag state="none">Not Supported</Tag>;
	}

	if(current.isEmpty()) {
		return <Tag state="none">Not Available</Tag>;
	}

	if (current.isSoldOut() && !current.isLos()) {
		return <Tag state="critical">Sold Out</Tag>;
	}

	if (current.isLos()) {
		return <Tag state="info">LOS {current.getLowestItemForRoom()?.lowestItem.item.leastPeriodOfStay}</Tag>;
	}

	const availabilityIndex = current.getLowestItemForRoom()?.availabilityIndex;

	if (availabilityIndex === AvailabilityIndex.SOLD_OUT) {
		return <span className="cursor-pointer"><Tag state="critical">Sold Out</Tag></span>;
	}
	if (availabilityIndex === AvailabilityIndex.NOT_AVAILABLE) {
		return <span className="cursor-pointer"><Tag state="none">Not Available</Tag></span>;
	}
	if (availabilityIndex === AvailabilityIndex.HIGH) {
		return <span className="cursor-pointer"><Tag state="success">High</Tag></span>;
	}
	if (availabilityIndex === AvailabilityIndex.CANNOT_BE_DETERMINED) {
		return <span className="cursor-pointer"><Tag state="critical">Undetermined</Tag></span>;
	}
	if (availabilityIndex === AvailabilityIndex.MODERATE || availabilityIndex === AvailabilityIndex.LOW) {
		return <span className="cursor-pointer">
			<Tag state="warning">{Utilities.snakeCaseToWords(availabilityIndex)}</Tag>
		</span>;
	}

	return null;
};

export default DisplayAvailabilityIndexTag;